import React, { useMemo } from 'react'

import { IPlacementContext, PlacementContext } from '../../contexts/placement-context'
import { CompactCtaContext } from '../../contexts/compact-cta-context'
import { PageHeaderType, TypeHeader } from '../../lib/types'
import { isUnresolvedLink } from '../../lib/utils/contentful-entry'
import { CtaRenderer, AnyCta } from '../item/cta-renderer'
// On local builds, there is an issue importing from ui-lib/header/index, possibly an import order conflict or cycle
import { HeaderNoNavigation } from '../ui-lib/header/no-navigation'
import { HeaderGlobal } from '../ui-lib/header/global'
import { HeaderGlobalTools } from '../ui-lib/header/global/tools'

import styles from '../item/cta-button/cta-button.module.scss'
import { isTypeComponentEmptyStub } from '@lib/types/content-types'

const placement = 'Header'

const StickyCtas = (props: { ctas: AnyCta[] }) => {
  const additionalProps = { ctaButtonAndUnderLinkContainerClassName: styles.ctaButtonAndUnderLinkContainerFullWidth }

  return (
    <CompactCtaContext.Provider value={true}>
      {props.ctas
        .filter((cta) => cta && !isUnresolvedLink(cta))
        .map((cta, index) => (
          <CtaRenderer cta={cta} additionalProps={additionalProps} key={`header-cta-${index}`} />
        ))}
    </CompactCtaContext.Provider>
  )
}

const shouldRenderCta = (cta: AnyCta | undefined) => cta && !isUnresolvedLink(cta) && !isTypeComponentEmptyStub(cta)

export const PageHeader: React.FC<{ header?: TypeHeader }> = ({ header }) => {
  const { internalName, type, stickyCtas } = header?.fields || {}

  const placementContext = useMemo<IPlacementContext>(
    () => ({ placement, placementInternalName: internalName }),
    [internalName]
  )

  const ctas = stickyCtas && <StickyCtas ctas={stickyCtas.filter(shouldRenderCta)} />

  return (
    <PlacementContext.Provider value={placementContext}>
      <CompactCtaContext.Provider value={true}>
        {type === PageHeaderType.NoNavigation && <HeaderNoNavigation ctas={ctas} />}
        {(type === PageHeaderType.Global || type === PageHeaderType.GlobalBusiness) && <HeaderGlobal ctas={ctas} />}
        {type === PageHeaderType.GlobalTools && <HeaderGlobalTools ctas={ctas} />}
      </CompactCtaContext.Provider>
    </PlacementContext.Provider>
  )
}
